import React from "react";
import { connect } from "react-redux";
import { Button, ValidationGroup, List } from "devextreme-react";

import { setDataForms, nextStep, doUploadFile, doDeleteSingleFile, setStep } from "../../actions";
import TextField from "../../../../../../Shared/fields/TextField";
import SelectField from "../../../../../../Shared/fields/SelectField";
import RadioGroupfield from "../../../../../../Shared/fields/RadioGroupField";
import FileUploaderField from "../../../../../../Shared/fields/FileUploaderField";
import helper from "../../../../../../../helpers/validaciones";
import DateField from "../../../../../../Shared/fields/DateField";
import NumberField from "../../../../../../Shared/fields/NumberField";

const DocumentType = {
  contrato: "CONTRATO",
  retenciones: "RET"
}

class InfoTrabajador extends React.PureComponent {
  constructor(props) {
    super(props);

    this.maxFileSize = process.env.REACT_APP_MAX_FILE_FIELD_SIZE_UPLOAD_IN_BM * 1000000

    this.state = {
      firstEdit: !props.editingDraft,
    };
    this.topRef = React.createRef();
  }

  handleNext = (params) => {
    const result = params.validationGroup.validate();

    if (result.isValid) {
      const jsonData = { ...this.props.jsonData };
      this.topRef.current.scrollIntoView();
      jsonData.step1Complete = true;
      jsonData.step2Complete = false;
      jsonData.step3Complete = false;
      jsonData.step4Complete = false;
      jsonData.FinancialBenefitType = this.props.jsonData.formInfoTrabajador.IdTipoPrestacion;

      this.props.dispatch(setDataForms(jsonData));
      this.props.onSave(false);
      const step = jsonData.middleStepsEnabled ? 2 : 3;
      this.props.dispatch(setStep(step));
      this.props.dispatch(nextStep());
    }
  }


  handleChange = async (e) => {
    const jsonData = { ...this.props.jsonData };
    if (e.value !== null) {
      jsonData.formInfoTrabajador[e.element.id] = e.value;

      if(jsonData.formInfoTrabajador.IdTipoPrestacion === 'S1' || jsonData.formInfoTrabajador.IdTipoPrestacion === 'S2') {
          const santander = this.props.listaBancos.find((b) => b.Banco === "BANCO SANTANDER-CHILE");
          jsonData.formInfoTrabajador.Bank = santander ? santander.Codigo : "037";
          jsonData.formInfoTrabajador.FormaPago= "Vale Vista";
      }

      switch (e.element.id) {
        case "fechaContrato": {
          if (e.value) {
            const result = await helper.calculoMeses(e.value, jsonData.fechaInicioUltimoReposo);
            jsonData.monthsDisplay = result.Meses;
            jsonData.middleStepsEnabled = result.middleStepsEnabled;
            jsonData.monthsDate = result.MesesDate;

            if (result.numeroMeses === 0) {
              jsonData.formInfoLaboral = {};
              jsonData.step1Complete = true;
              jsonData.step2Complete = false;
              jsonData.step3Complete = false;
              jsonData.step4Complete = false;
            }
          }
          break;
        }
        case "FormaPago": {
          if (e.value === "Vale Vista") {
            const santander = this.props.listaBancos.find((b) => b.Banco === "BANCO SANTANDER-CHILE");
            jsonData.formInfoTrabajador.Bank = santander ? santander.Codigo : "037";
          }
          break;
        }
        case "contratoTrabajo": {
          const rutWorker = helper.formatRut(jsonData.formInfoTrabajador.Rut, { showDots: false, showHyphen: true });
          jsonData.container = `${rutWorker}${this.props.userData.RUT}${jsonData.idFinancialBenefit}`;

          if (e.value) {
            const archivo = e.value[0];
            const data = {};
            data.rutTrabajador = rutWorker;
            data.rutUsuario = this.props.userData.RUT;
            data.idPrestacion = jsonData.idFinancialBenefit;
            data.files = archivo;
            data.type = DocumentType.contrato;
            if (jsonData.formInfoTrabajador.contratoTrabajo !== "") {
              this.props.dispatch(doDeleteSingleFile({
                rutTrabajador: rutWorker,
                rutUsuario: this.props.userData.RUT,
                idPrestacion: jsonData.idFinancialBenefit,
                NombreArchivo: jsonData.formInfoTrabajador.contratoTrabajo[0].name,
              }, false));
            }
            this.props.dispatch(doUploadFile(data, () => {
              jsonData.formInfoTrabajador.contratoTrabajo = archivo.name;
            }));
          }
          break;
        }
        case "oficio": {
          const rutWorker = helper.formatRut(jsonData.formInfoTrabajador.Rut, { showDots: false, showHyphen: true });
          jsonData.container = `${rutWorker}${this.props.userData.RUT}${jsonData.idFinancialBenefit}`;

          if (e.value) {
            const archivo = e.value[0];
            const data = {};
            data.rutTrabajador = rutWorker;
            data.rutUsuario = this.props.userData.RUT;
            data.idPrestacion = jsonData.idFinancialBenefit;
            data.files = archivo;
            // archivo de retenciones judiciales
            data.type = DocumentType.retenciones;
            if (jsonData.formInfoTrabajador.oficio !== "") {
              this.props.dispatch(doDeleteSingleFile({
                rutTrabajador: rutWorker,
                rutUsuario: this.props.userData.RUT,
                idPrestacion: jsonData.idFinancialBenefit,
                NombreArchivo: jsonData.formInfoTrabajador.oficio[0].name,
                type: "RET"
              }, false));
            }
            this.props.dispatch(doUploadFile(data, () => {
              jsonData.formInfoTrabajador.oficio = archivo.name;
            }));
          }
          break;
        }
        default:
          break;
      }


      this.props.dispatch(setDataForms(jsonData));
      if (this.state.firstEdit && !this.props.editingDraft && jsonData.Id === null) {
        this.setState({ firstEdit: false });
        // se crea el draf
        this.props.onCreate();
      }
    }
  }


  emailValidation = (e) => {
    if (e.value !== null && helper.validarEmail(e.value)) {
      return true;
    }

    return false;
  }


  eliminoDcto(dcto, property, type) {
    const jsonData = { ...this.props.jsonData };
    const rutWorker = helper.formatRut(jsonData.formInfoTrabajador.Rut, { showDots: false, showHyphen: true });
    jsonData.container = `${rutWorker}${this.props.userData.RUT}${jsonData.idFinancialBenefit}`;
    jsonData.formInfoTrabajador[property] = null;
    this.props.dispatch(doDeleteSingleFile({
      rutTrabajador: rutWorker,
      rutUsuario: this.props.userData.RUT,
      idPrestacion: jsonData.idFinancialBenefit,
      NombreArchivo: dcto,
      type: type
    }, true));
    this.props.dispatch(setDataForms(jsonData));
  }

  renderDocument = (nmbDcto, property, titulo, type) => {
    const list = this.props.listaDocumentosIngresados.filter((item) => item.Nombre === nmbDcto && item.tipo === type);
    return (
      <React.Fragment>
        <div style={{ marginBottom: 10, marginTop: 10 }}>
          <span className="title">  {titulo} </span>
          <List
            className="draf-document-list"
            scrollByContent
            selectedIndex={2}
            noDataText="Sin documentos"
            items={list}
            itemComponent={(item) => (
              <div className="list-document-wrapper">
                <div className="text">
                  <span className="text"> <i className="material-icons" style={{ fontSize: 10 }} > attach_file </i> {item.Nombre}</span>
                </div>

                <div style={{ paddingLeft: 5 }} >
                  <Button
                    stylingMode="text"
                    className="material-icons"
                    style={{
                      backgroundColor: "Transparent",
                      border: "none",
                    }}
                    key={`${item.Nombre}_eliminar`}
                    onClick={() => this.eliminoDcto(item.Nombre, property, item.tipo)}
                  >
                    <i className="material-icons" style={{ fontSize: 10 }} > delete </i>
                  </Button>
                </div>
              </div>
            )}
          />
        </div >
      </React.Fragment>
    );
  }
  renderFormasDePago = (form) => {
    let seccion = null;

    if (form.FormaPago === "Vale Vista") {
      seccion = (
        <SelectField
          label="Banco"
          id="Bank"
          value={form.FormaPago !== "Vale Vista" ? form.Bank : "037"}
          dataSource={this.props.listaBancos}
          displayExpr="Banco"
          valueExpr="Codigo"
          disabled
          onValueChanged={this.handleChange}
        />
      );
    }
    if (form.FormaPago === "Transferencia electrónica") {
      seccion = (
        <React.Fragment>
          <SelectField
            label="Banco"
            id="Bank"
            value={form.Bank}
            dataSource={this.props.listaBancos}
            displayExpr="Banco"
            required
            valueExpr="Codigo"
            onValueChanged={this.handleChange}
          />

          <NumberField
            label="Número de cuenta"
            id="AccountNumber"
            required
            min={0}
            skipParse
            defaultValue={0}
            value={form.AccountNumber || 0}
            onChange={this.handleChange}

          />
        </React.Fragment>

      );
    }

    return seccion;
  }


  render() {
    const form = { ...this.props.jsonData.formInfoTrabajador };

    return (

      <React.Fragment>
        {!helper.isEmpty(form) && (
          <ValidationGroup className="row" >

            <div className="col-12 newDenuncia-title" ref={this.topRef}>
              <h2>Información del trabajador</h2>
              <p>Completa los datos para pasar a la siguiente sección</p>
            </div>
            <div className="col-12">
              <h4 className="newDenuncia-subtitle">Datos trabajador</h4>
              <TextField
                label="Rut"
                disabled
                id="Rut"
                value={form.Rut}
                onChange={this.handleChange}
              />
              <TextField
                label="Nombre trabajador"
                disabled
                id="Nombre"
                value={`${form.FirstName} ${form.LastName}`}
                onChange={this.handleChange}
              />
              <TextField
                label="Correo electrónico"
                id="email"
                value={form.email}
                onChange={this.handleChange}
                required
                customRules={{
                  type: "custom",
                  validationCallback: this.emailValidation,
                  message: "Formato de mail no coincide",
                }
                }
              />


            </div>


            <div className="col-12">
              <h4 className="newDenuncia-subtitle">Contrato de trabajo</h4>

              <DateField
                label="Fecha de contratación del trabajador"
                id="fechaContrato"
                required
                max={this.props.jsonData.fechaInicioUltimoReposo}
                value={form.fechaContrato}
                onChange={this.handleChange}
                type="date"
              />

              <FileUploaderField
                id="contratoTrabajo"
                subLabel={`Recuerda adjuntar todos los contratos del trabajador en un solo archivo en el caso que estos sean mensuales. Formato PDF y máximo ${process.env.REACT_APP_MAX_FILE_FIELD_SIZE_UPLOAD_IN_BM} MB`}
                label="Adjuntar contrato de trabajo"
                text="Adjuntar contrato"
                multiple={false}
                required
                formats="application/pdf"
                maxFileSize={this.maxFileSize}
                uploadMode="useForm"
                onChange={this.handleChange}
                validar={form.contratoTrabajo == null}
              />
              {
                form.contratoTrabajo && this.renderDocument(form.contratoTrabajo, "contratoTrabajo", "Contrato de trabajo", DocumentType.contrato.toLowerCase())
              }


            </div>

            <div className="col-12">
              <h4 className="newDenuncia-subtitle">Retenciones judiciales del trabajador</h4>
              <RadioGroupfield
                label="El trabajador tiene retenciones judiciales"
                items={["Si", "No"]}
                id="RetencionesJudiciales"
                required
                defaultValue="Si"
                value={form.RetencionesJudiciales}
                onValueChanged={this.handleChange}
                layout="horizontal"
              />
              {form.RetencionesJudiciales === "Si" &&
                (
                  <React.Fragment>
                    <FileUploaderField
                      id="oficio"
                      text="Adjuntar oficio"
                      label="Adjuntar oficio"
                      disabled={!((this.state.enabledOficio === true || form.RetencionesJudiciales === "Si"))}
                      multiple={false}
                      required
                      formats="application/pdf"
                      maxFileSize={this.maxFileSize}
                      uploadMode="useForm"
                      onChange={this.handleChange}
                      validar={form.oficio == null}
                    />

                    {form.oficio && this.renderDocument(form.oficio, "oficio", "Retenciones judiciales", DocumentType.retenciones.toLowerCase())}
                  </React.Fragment>
                )
              }
            </div>

            <div className="col-12">
              <h4 className="newDenuncia-subtitle">Medio de pago trabajador</h4>
              <SelectField
                label="Medio de pago"
                id="FormaPago"
                required
                disabled={form.IdTipoPrestacion === 'S1' || form.IdTipoPrestacion === 'S2'}
                value={form.IdTipoPrestacion === 'S1' || form.IdTipoPrestacion === 'S2' ? 'Vale Vista' : form.FormaPago}
                onValueChanged={this.handleChange}
                items={["Transferencia electrónica", "Vale Vista"]}
              />
              <p className='discleimerMessage'>Para entidades públicas o empresas con convenio de pago de subsidios, los pagos se realizarán a la cuenta indicada en el mandato o en el oficio/carta de cobro</p>

              {this.renderFormasDePago(form)}

              <TextField
                label="Tipo de prestación económica"
                id="TipoPrestacionEconomica"
                disabled
                value={form.TipoPrestacion}
              />

            </div>

            <div className="col-12">
              <Button
                key="infoTrabajadorBtn"
                text="Siguiente"
                type="success"
                className="newDenuncia-next-button"
                onClick={this.handleNext}
                useSubmitBehavior
              />
            </div>

          </ValidationGroup>

        )}

      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  jsonData: state.prestacionesEmpresa.jsonData,
  showHideForm: state.prestacionesEmpresa.showHideForm,
  editingDraft: state.prestacionesEmpresa.editingDraft,
  listaBancos: state.global.listaBancos,
  userData: state.global.userData,
  listaTiposCuenta: state.global.listaTiposCuenta,
  listaDocumentosIngresados: state.prestacionesEmpresa.listaDocumentosIngresados,
  IdDraft: state.prestacionesEmpresa.IdDraft,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoTrabajador);
